export default __webpack_public_path__ + "static/media/chiboi.3ddaa2b1.png";